<template>
  <div class="grid-content bg-purple-light">
    <el-button v-show="show" type="primary" round size="small" :disabled="disabled" @click="getCode">获取验证码</el-button>
    <span v-show="!show" class="count">{{ count }} s</span>
  </div>
</template>

<script>
import {sendSms} from '@/api/commonApi'
  export default {
    props:{
      apiFun:{
        type: Function,
        default: sendSms
      },
      disabled:{
        type:Boolean,
        default:false
      },
     queryObj:{
       type:Object,
       default(){
			   return {
           code:'',
           phone:'',
           codes:'',
         }
		   }
     }
    },
    
    data(){
      return {
        show:true,
        count:0,
        timer:null, 
      }
    },
    watch:{
      show:{
        handler(newValue) {
          this.$store.commit('components/GET_VERIFICATECODE',newValue)
        },
        immediate:true,
      },
      'queryObj.phone':{
        handler(newValue) {
          if(!newValue && this.timer) {
			      this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    },
    created(){},
    methods:{
       //获取验证码
   getCode() {
			this.apiFun(this.queryObj).then(response => {
			  if (response.status == 0) {
			    const TIME_COUNT = 60;
			    if (!this.timer) {
			      this.count = TIME_COUNT;
			      this.show = false;
			      this.timer = setInterval(() => {
			        if (this.count > 0 && this.count <= TIME_COUNT) {
			          this.count--;
			        } else {
			          this.show = true;
			          clearInterval(this.timer);
			          this.timer = null;
                this.$emit('selectItem') 
			        }
			      }, 1000);
			    }
          this.$emit('getSms',response.data)
			  }
			});
		},
    },
  }
</script>
<style scoped lang='scss'>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
  border:1px dashed #c0ccda;

}
::v-deep .el-image .image-slot{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399
}
.lebal{
  white-space: nowrap;
  width:190px;
}
.bg-purple-light{
  position: relative;
  .count{
    position: absolute;
    left: 10px;
    top:8px;
  }
}

</style>